import { Component, ComponentChildren } from "preact";

interface Props {
    children: ComponentChildren;
    fallback?: (error: Error) => ComponentChildren;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback(this.state.error!);
            }
            return (
                <div style={{ padding: "2rem", textAlign: "center", color: "var(--pico-del-color)" }}>
                    <h3>Something went wrong.</h3>
                    <details style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                        {this.state.error && this.state.error.toString()}
                    </details>
                    <button onClick={() => window.location.reload()} className="outline">
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
